import { Avatar, Card, CardContent, Grid, Typography } from '@mui/material'
import * as React from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import Ratings from 'react-ratings-declarative'

import images from '../../constants/images'
import TestimonialT from '../../types/TestimonialT'


const testimonials: Array<TestimonialT> = [
  {
    blurb: 'These guys really are beasts!  I gave them money and pizza and they moved my stuff quickly without damaging it.',
    firstName: 'Sara',
    lastName: 'J.',
    image: images.sara,
    postDate: 'Aug 9, 2021',
    rating: 5
  },
  {
    blurb: 'Alex and David were the best movers I\'ve had so far.  Very happy with Beast Moving and will hire them again.',
    firstName: 'Thomas',
    lastName: 'N.',
    image: images.thomas,
    postDate: 'Jan 15, 2022',
    rating: 5
  },
  {
    blurb: 'These guys are hands down the fastest and safest movers in Denver.  Thanks for moving me and my family.',
    firstName: 'Jeremy',
    lastName: 'S.',
    image: images.jeremy,
    postDate: 'Aug 9, 2021',
    rating: 5
  }
]


interface TestimonialsProps {

}


const Testimonials: React.FC<TestimonialsProps> = (): JSX.Element => {
  return (
    <>
      <Grid container spacing={2}>
        {testimonials.map((testimonial: TestimonialT): JSX.Element => {
          return (
            <Grid item xs={12} sm={4} style={{ textAlign: "center" }}>
              <Card style={{ borderRadius: 14, boxShadow: "none", border: "1px solid #dee2e6" }}>
                <CardContent style={{ padding: '16px 14px' }}>
                  <div className='mb-2 mt-2 d-flex justify-content-center'>
                    <Avatar alt={testimonial.firstName} src={testimonial.image} style={{ width: 70, height: 70 }} />
                  </div>
                  <Ratings
                    rating={testimonial.rating}
                    widgetDimensions='22px'
                    widgetHoverColors='#f26000'
                    widgetRatedColors='#fed8b1'>
                    <Ratings.Widget />
                    <Ratings.Widget />
                    <Ratings.Widget />
                    <Ratings.Widget />
                    <Ratings.Widget />
                  </Ratings>
                  <h6 className='mt-2 mb-1'>{testimonial.firstName} {testimonial.lastName}</h6>
                  <p style={{ fontSize: '0.85rem', color: '#555', margin: 0 }}>{testimonial.blurb}</p>
                </CardContent>
              </Card>
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}


export default Testimonials
